import { VideoStatus } from '@statsbomb/parachute-types';
import { useTranslation } from 'react-i18next';
import { stripTags } from '@/utils/translations';

export const usePlayButtonFeedback = (videoStatus?: VideoStatus) => {
  const { t } = useTranslation('video');

  if (videoStatus === 'disabled') return stripTags(t('upgradeLicence')); // upgradeLicence contains placeholder tags
  if (videoStatus === 'restricted') return t('noLicence');
  return undefined;
};
